import petAPI from '@/app/apis/main/pets/pets-api.js';

export default {
    /**
	 * @return {object} pet list
	 * @param {*} tableDetails - Contains pagination data
	 */
	async getPets(tableDetails) {
		return petAPI.getPets(tableDetails);
	},

	async reactivatePet(petId){
		return petAPI.reactivePet(petId);
	}
}